import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from '@components/I18nProvider';

import { convertThumbnailToPictureImage } from '@tager/web-modules';

import { media } from '@/utils/mixin';
import { PostShort } from '@/typings/model';
import Picture from '@/components/Picture';
import { getPostDate, getPostUrl } from '@/utils/posts';
import Link from '@/components/Link';
import PostMeta from '@/components/PostMeta/PostMeta';

type Props = {
  post: PostShort;
};

function OtherPost({ post }: Props) {
  const { t } = useTranslation();

  return (
    <PostItem>
      {post.coverImage ? (
        <Image>
          <Link to={getPostUrl(post)}>
            <Picture
              tabletSmall={convertThumbnailToPictureImage(
                post.coverImage.preview
              )}
              mobileSmall={convertThumbnailToPictureImage(
                post.coverImage.previewMobile
              )}
            />
          </Link>
        </Image>
      ) : null}
      <Content>
        <Link as={Title} to={getPostUrl(post)}>
          {post.title}
        </Link>
      </Content>
      <Footer>
        <PostMeta
          date={getPostDate(post.date, t)}
          category={
            post.categories && post.categories.length
              ? post.categories[0].name
              : null
          }
        />
      </Footer>
    </PostItem>
  );
}

const PostItem = styled.div`
  width: 350px;
  margin-left: 50px;
  &:first-child {
    margin-left: 0;
  }
  ${media.mobile(css`
    display: block;
    margin-left: 0;
    margin-bottom: 40px;
    width: auto;
  `)}
`;
const Title = styled.a`
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  &:hover {
    color: #ed4040;
  }
`;

const Content = styled.div`
  height: 43px;
  margin-bottom: 12px;
  margin-top: 10px;
  overflow: hidden;
  ${media.mobile(css`
    margin-top: 0;
  `)}
`;

const Image = styled.div`
  &:hover + ${Content} {
    ${Title} {
      color: #ed4040;
    }
  }
  ${media.mobile(css`
    margin: 0 -15px 5px;
    width: auto;
    max-height: 172px;
    overflow: hidden;
    position: relative;
    height: 172px;
    img {
      vertical-align: middle;
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      width: 100%;
    }
  `)}
`;

const Footer = styled.div``;

export default OtherPost;
